import { oc } from '@orpc/contract';
import { approvalSchema, requestApprovalInputSchema } from '../schemas/approvals.schemas.js';
/**
 * Asks an administrator to allow a purchase above the calculated ceiling. The request is bound to the
 * **fingerprint of a saved snapshot** — the service saves one first when the latest is stale — so the
 * decision can only ever authorise the state it was shown (plan §5.6).
 */
export const requestApprovalContract = oc
    .route({
    method: 'POST',
    path: '/approvals/request',
    tags: ['Approvals'],
    summary: 'Request approval to buy above the ceiling',
})
    .input(requestApprovalInputSchema)
    .output(approvalSchema);
//# sourceMappingURL=request-approval.contract.js.map